import React, { useState , useRef, useEffect} from 'react'
import { Wrapper, ButtonWrapper, Box, Check, Shadow, Input, Label } from './styled'


// props.value måste vara true eller false
export default (props) => {
  const { label, value = '', checked, disabled, save = () => { }, name = 'checkbox', onSelect, onSelectAll, rowId } = props;

  const [isChecked, setIsChecked] = useState(checked)
  const [animate, setAnimate] = useState(false)

  const animateButton = () => {
    setAnimate(!animate)
    setTimeout(() => setAnimate(false), 400)
  }

  const onCheck = (animate = true) => {
    if (!disabled) {
      animate && animateButton()
      setIsChecked(!isChecked)
      // not sure why we have name here, but we keep it not to break anything. 2021-03
      save({name,key:name, value : value ? value : label})
      // onChange(value ? value : label)
      if(onSelectAll) {
        onSelectAll()
      } else {
      onSelect(rowId)
      }
    }
  }

  const currentRef = useRef();

  useEffect( () => {
    if( currentRef.current) {
      setIsChecked(checked)
    } else {
      currentRef.current = true
    }
  }, [checked])

  return (
    <Wrapper>
      <ButtonWrapper onClick={onCheck} disabled={disabled}>
        <Box checked={isChecked} disabled={disabled}>
          {isChecked ? <Check className="far fa-check" /> : ''}
        </Box>
        <Shadow className={animate ? 'animate' : ''} />
        <Input type="checkbox" onChange={onCheck} disabled={disabled} />
      </ButtonWrapper>
      {label && <Label onClick={() => onCheck(false)} disabled={disabled}>{label}</Label>}
    </Wrapper>
  )
}